import { TeamType, AuthenticationEvents } from "@teaming/common-enums";
import { debounce } from "@teaming/common-util";
import { listenTo } from "@teaming/io-helpers";
import debugFactory from "debug";

const debug = debugFactory( "teaming:teaming-web:stores:host-layout" );

export default function layoutChannelWireUp( { auth, ioChannel, store, } ) {
	auth.on(
		AuthenticationEvents.LOGIN,
		( { userProfile, auth0User, } ) => {
			debug( "handling Authentication.LOGIN", userProfile );
			store.commit( "host-layout/receiveUserProfile", { userProfile, } );
			if ( auth0User.email_verified ) {
				ioChannel.publish( "team.fetchMyFavoriteOneOnOnes.invoke", {} );
				ioChannel.publish( "team.fetchMyFavoriteTeams.invoke", {} );
			}
		}
	);

	auth.on(
		AuthenticationEvents.SIGNUP,
		( { userProfile, } ) => {
			debug( "handling Authentication.SIGNUP", userProfile );
			store.commit( "host-layout/receiveUserProfile", { userProfile, } );
		}
	);

	listenTo( ioChannel, "user.getUserProfile", {
		success: ( { response: userProfile, } ) => {
			// need to know about the current user in NavSidebar
			store.commit( "host-layout/receiveUserProfile", { userProfile, } );
		},
	} );

	//
	// NavSidebar
	// favorite teams
	//

	listenTo( ioChannel, "team.fetchMyFavoriteTeams", {
		success: ( { response: favoriteTeams, } ) => {
			store.commit( "host-layout/receiveFavoriteTeams", { favoriteTeams, } );
		},
	} );

	listenTo( ioChannel, "team.favoriteTeam", {
		success: ( { args, } ) => {
			const { teamId, } = args[ 0 ];
			ioChannel.publish( "team.fetchTeam.invoke", { teamId, } );
		},
	} );

	listenTo( ioChannel, "team.unfavoriteTeam", {
		success: ( { args, } ) => {
			const { teamId, } = args[ 0 ];
			store.commit( "host-layout/receiveUnfavoriteTeam", { teamId, } );
		},
	} );

	listenTo( ioChannel, "team.fetchTeam", {
		success: ( { response: team, } ) => {
			if ( team.type === TeamType.TEAM && team.isFavorited ) {
				store.commit( "host-layout/receiveFavoriteTeams", {
					favoriteTeams: [ team, ], }
				);
			}
		},
	} );

	//
	// NavSidebar
	// favorite 1:1s
	//

	listenTo( ioChannel, "team.fetchMyFavoriteOneOnOnes", {
		success: ( { response: favoriteOneOnOnes, } ) => {
			store.commit( "host-layout/receiveFavoriteOneOnOnes", { favoriteOneOnOnes, } );
		},
	} );

	listenTo( ioChannel, "team.unfavoriteOneOnOne", {
		success: ( { args, } ) => {
			const { oneOnOneId, } = args[ 0 ];
			store.commit( "host-layout/receiveUnfavoriteOneOnOne", { oneOnOneId, } );
		},
	} );

	listenTo( ioChannel, "team.fetchOneOnOne", {
		success: ( { response: team, } ) => {
			if ( team.type === TeamType.ONE_ON_ONE && team.isFavorited ) {
				store.commit( "host-layout/receiveFavoriteOneOnOnes", {
					favoriteOneOnOnes: [ team, ], }
				);
			}
		},
	} );

	//
	// global window listeners
	//

	listenTo( ioChannel, "team.leaveTeam", {
		success: ( { args, } ) => {
			const { teamId, } = args[ 0 ];
			store.commit( "host-layout/removeTeam", { teamId, } );
		},
	} );

	window.addEventListener( "resize", debounce( () => {
		// close the mobile sidebar if the window is resized
		store.commit( "host-layout/closeNavSidebar" );
	}, 100 ) );
}
